import React, { } from 'react';
import { slugify } from '@utils'

import { MenuItem } from './MenuItem'

export const SubMenu = ({ ctx, items, level, path, isMega, highlight }) => {
  return (
    <>
      {
        level == 1 && highlight && <div className="Nav__header">
          <div className="Card Card--navHighlight has-link">

            <figure className="Card__media" data-layout="image-cover">
              <img src={highlight.image} loading="lazy" alt={highlight.title} />
            </figure>
            <div className="Card__content">
              <a href={highlight.cta_link} className="Button" data-style="text blue">{highlight.cta_label}</a>
              <h6 className="Card__title">{highlight.title}</h6>
            </div>
          </div>
        </div>
      }
      <div className={`Nav ${!isMega ? 'Nav--vertical' : ''}`}>
        {items.map((link, index) => {
          return (
            <MenuItem ctx={ctx} link={link} level={level + 1} key={link.title} path={`${path}_${slugify(link.title)}`}></MenuItem>
          );
        })}

      </div>
    </>
  );
};